import { useMemo } from 'react'

import { format, isValid, parse } from 'date-fns'

export const useGetBenefitsResetDate = (clientDetails?: { session_count_starts_on?: string } | null) => {
  return useMemo(() => {
    if (!clientDetails?.session_count_starts_on) return ''

    try {
      const today = new Date()
      const currentYear = today.getFullYear()
      const nextYear = currentYear + 1

      // Parse the reset date with current year
      const resetDateThisYear = parse(
        `${clientDetails.session_count_starts_on}-${currentYear}`,
        'MMM-dd-yyyy',
        new Date(),
      )

      if (!isValid(resetDateThisYear)) {
        return ''
      }

      // Create a new date object for the result
      const benefitsResetDate = new Date(resetDateThisYear)

      // Special cases
      const isJanuaryFirst = today.getMonth() === 0 && today.getDate() === 1
      const isResetDateJanuaryFirst = resetDateThisYear.getMonth() === 0 && resetDateThisYear.getDate() === 1
      const isDecemberThirtyFirst = today.getMonth() === 11 && today.getDate() === 31

      // Determine if we should use next year
      let useNextYear = false

      if (isDecemberThirtyFirst) {
        // If today is Dec 31, always use next year
        useNextYear = true
      } else if (isJanuaryFirst && isResetDateJanuaryFirst) {
        // If today is Jan 1 and reset date is Jan 1, use next year
        useNextYear = true
      } else {
        // For all other cases, use next year if the reset date has passed or is today
        useNextYear = resetDateThisYear <= today
      }

      if (useNextYear) {
        benefitsResetDate.setFullYear(nextYear)
      }

      return format(benefitsResetDate, 'MMM dd, yyyy')
      // eslint-disable-next-line unused-imports/no-unused-vars
    } catch (error) {
      return ''
    }
  }, [clientDetails?.session_count_starts_on])
}
